import { postData, getData, putData, deleteData } from '../axiosServices'

export const addCOE = (formData) => {

    const url = 'coe';
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, formData, { headers });
}
export const getAllCOE = () => {
    let url = 'coe'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const updateCOE = (id, data) => {
    let url = `coe/${id}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, data, { headers })
}
export const disableCOE = (id) => {
    let url = `coe/${id}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return deleteData(url, { headers })
}
export const addStudentsCSV = (coeID, groupName, data) => {
    const url = `coe/${coeID}/${groupName}/learners/upload`;
    const headers = {
        'Content-Type': "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, data, { headers });
}
export const addSingleLearner = (coeID, groupName, data) => {
    const url = `coe/${coeID}/${groupName}/learners/upload`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, data, { headers });
}
export const addLabCSV = (coeID, data) => {
    const url = `labs/upload/coe/${coeID}`;
    const headers = {
        'Content-Type': "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, data, { headers });
}
export const getAllGroups = () => {
    let url = 'learners/groupNames'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getAllLearners = (coeID) => {
    let url = `coe/${coeID}/learners`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getInactiveLearners = (coeID) => {
    let url = `coe/${coeID}/inactive-learners`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getAllAdmins = (coeID) => {
    let url = `admins/coe/${coeID}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getCoeAdminsByCoeId = (coeID) => {
    let url = `admins/coe/${coeID}/coe-admins`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getReportViewersByCoeId = (coeID) => {
    let url = `admins/coe/${coeID}/report-viewers`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const updateLearner = (id, data) => {
    let url = `learners/${id}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, data, { headers })
}
export const disableLearner = (id) => {
    let url = `learners/${id}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return deleteData(url, { headers })
}

export const assignAdminToCoe = (data) => {

    const url = 'coeCenterAdmin';
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, data, { headers });
}

export const getAllSemesters= (coeId) => {
    let url = `labs/coe/${coeId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return getData(url, { headers });
}
export const getAllEnrolmentYears= (coeId) => {
    let url = `labs/coe/${coeId}/enrolment-years`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return getData(url, { headers });
}